import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useUrlNumber } from "@/hooks/use-url-state";

export const RANGES = [7, 14, 30, 90];

/** Zeitraum in Tagen, gespeichert als ?days= in der URL. */
export function useRangeParam(defaultDays = 30) {
  return useUrlNumber("days", defaultDays);
}

export function RangeSelect({
  value,
  onChange,
}: {
  value: number;
  onChange: (days: number) => void;
}) {
  return (
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger className="w-40 bg-card" aria-label="Zeitraum">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {RANGES.map((d) => (
          <SelectItem key={d} value={String(d)}>
            Letzte {d} Tage
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
